// Import locales
import enUS from 'date-fns/locale/en-US';
import es from 'date-fns/locale/es';
import fr from 'date-fns/locale/fr';
import de from 'date-fns/locale/de';
import ru from 'date-fns/locale/ru';
import ja from 'date-fns/locale/ja';
import nl from 'date-fns/locale/nl';
import pt from 'date-fns/locale/pt';
import te from 'date-fns/locale/te';
import { getLocale } from '@hooks/useLocale';

// Map locale codes to date-fns locales
const localeMap = {
  en: enUS,
  es: es,
  fr: fr,
  de: de,
  ru: ru,
  ja: ja,
  nl: nl,
  pt: pt,
  te: te,
};

// Get current locale from cookie
export const getDateFnsLocale = () => {
  const locale = getLocale();
  return localeMap[locale] || enUS;
};
